import { DOCUMENT, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@env/environment';
import { filter } from 'rxjs';

declare var grecaptcha: any;

@Injectable({
  providedIn: 'root',
})
export class RecaptchaEnterpriseService {
  private readonly siteKey = environment.RECAPTCHA_KEY;
  private router = inject(Router);
  private document = inject(DOCUMENT);
  private scriptCargado = signal<boolean>(false);
  private unshieldedRoutes = ['/token-verification'];

  private cargarScriptGoogle(): void {
    if (this.scriptCargado() || !this.siteKey) return;
    const script = this.document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.scriptCargado.set(true);
      console.log('SDK de reCAPTCHA Enterprise cargado dinámicamente.');
    };
    this.document.head.appendChild(script);
  }

  public initRouteListener(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentUrl = event.urlAfterRedirects.split('?')[0];

        console.log(currentUrl);

        const needsRecaptcha = !this.unshieldedRoutes.includes(currentUrl);

        if (needsRecaptcha) {
          this.cargarScriptGoogle();
          this.document.body.classList.remove('hide-recaptcha');
          console.log('VER RECAPTCHA');
        } else {
          this.document.body.classList.add('hide-recaptcha');
          console.log('OCULTAR RECAPTCHA');
        }
      });
  }

  async executeAction(actionName: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
        return reject(
          'El SDK de reCAPTCHA Enterprise no se ha cargado correctamente.',
        );
      }
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(this.siteKey, {
            action: actionName,
          });
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    });
  }
}
